import React, { Component } from "react";
// import { Modal, TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import Heading, { HEADING_LEVEL, HEADING_SIZE } from "@acadia-ui/heading";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { createChildLineItems, setFilteredIO } from "../../Flux/Actions/LineItemActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "./ModalHelpers";
import InsertionOrderDataStore from "../../Flux/Stores/InsertionOrderDataStore";
import { putInsertionOrder } from "../../Flux/Actions/InsertionOrderActions";
import LineItemDataStore from "../../Flux/Stores/LineItemDataStore";
import WorkbookStore from "../../Flux/Stores/WorkbookStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import moment from "moment";
import Loading from "../../Components/LoadingSpinner";

import { ToastNotification, TOAST_TYPE, showToast } from "@acadia-ui/toast";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false
};

const formEl = "clone_platform_modal";

class ClonePlatformModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: moment(this.props.metaData.StartDate).format("YYYY/MM/DD"),
				EndDate: moment(this.props.metaData.EndDate).format("YYYY/MM/DD")
			},
			loading: false,
			...initialState,
			success: false,
			confirmOpen: false,
			childErrorModalOpen: false,
			changedFields: []
		};

		const componentTypeMap = {
			"Insertion Order": {
				dataStore: InsertionOrderDataStore,
				dataBucketName: "InsertionOrderData",
				IDName: "InsertionOrderID",
				taxonomyPropertyName: "InsertionOrderName"
			},
			"Line Item": {
				dataStore: LineItemDataStore,
				dataBucketName: "LineItemData",
				IDName: "LineItemID",
				taxonomyPropertyName: "LineItemName"
			}
		};

		const { dataStore, dataBucketName, IDName, taxonomyPropertyName } = componentTypeMap[this.props.type];

		this.dataStore = dataStore;
		this.dataBucketName = dataBucketName;
		this.IDName = IDName;
		this.taxonomyPropertyName = taxonomyPropertyName;

		this.childDataStore = componentTypeMap[this.props.childName].dataStore;
		this.childDataBucketName = componentTypeMap[this.props.childName].dataBucketName;
		this.childIDName = componentTypeMap[this.props.childName].IDName;
		this.childTaxonomyPropertyName = componentTypeMap[this.props.childName].taxonomyPropertyName;
	}

	componentDidMount() {
		this.props.clonePlatformModal(this);
		InsertionOrderDataStore.on("duplicate_insertionOrder_fail", this.handleErrors);
		InsertionOrderDataStore.on("duplicate_insertionorder_success", this.handleSuccess);
		InsertionOrderDataStore.on("insertionorder__errors__reset", this.handleReset);
		LineItemDataStore.on("child_lineitems_created", this.childCreated);
		LineItemDataStore.on("child_lineitems_failed", this.childFailed);
	}

	componentWillUnmount() {
		this.props.clonePlatformModal(undefined);
		InsertionOrderDataStore.removeListener("duplicate_insertionOrder_fail", this.handleErrors);
		InsertionOrderDataStore.removeListener("duplicate_insertionorder_success", this.handleSuccess);
		InsertionOrderDataStore.removeListener("insertionorder__errors__reset", this.handleReset);
		LineItemDataStore.removeListener("child_lineitems_created", this.childCreated);
		LineItemDataStore.removeListener("child_lineitems_failed", this.childFailed);
	}

	childCreated = () => {
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Line Items have been successfully created." timed={5000} />);
		this.setState({ loading: false }, () => {
			this.closeConfirmationModal();
			this.triggerOpenClose();
			this.props.navigateToChild();
			this.props.updateCounts(this.props.childName.replace(/\s+/g, ""));
			this.props.updateCounts(this.props.type.replace(/\s+/g, ""));
		});
	};

	childFailed = () => {
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Insertion Order was created but an error occured creating some Line Items." />);
		this.setState({ childErrorModalOpen: true, loading: false }, () => {
			this.props.updateCounts(this.props.type.replace(/\s+/g, ""));
			this.triggerOpenClose();
			this.props.refresh();
			this.props.navigateToChild();
		});
	};

	handleSuccess = () => {
		let success = false;
		[...document.getElementsByClassName("bx--btn bx--btn--secondary")].forEach((element) => {
			if (element.innerHTML === "Create and Add Another") {
				element.disabled = false;
			}
		});
		if (!this.state.closeModal) {
			if (this.props.type === "Insertion Order") {
				InsertionOrderDataStore.resetInsertionOrderErrors();
			}
			success = true;
		}
		this.setState({ loading: false, success }, () => {
			this.triggerOpenClose();
			this.props.refresh();
			this.props.updateCounts(this.props.type.replace(/\s+/g, ""));
			if (success) {
				const successConfirmation = document.getElementById("successConfirmation");
				if (successConfirmation) {
					successConfirmation.scrollIntoView();
				}
			}
			showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Insertion Order cloned successfully." timed={5000} />);
		});
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			[...document.getElementsByClassName("bx--btn bx--btn--secondary")].forEach((element) => {
				if (element.innerHTML === "Create and Add Another") {
					element.disabled = false;
				}
			});
			const errors = this.dataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const type = "duplicate platform";
				this.setState({ errors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Insertion Order could not be cloned." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (!this.state.open) {
					const modals = document.getElementsByClassName("bx--modal-content");
					if (this.props.config) {
						const fieldCount =
							this.props.config[this.dataBucketName].filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.TaxonomyData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length +
							this.props.config.MetaData.filter((field) => {
								return field.FieldType !== "Hidden";
							}).length;
						if (modals) {
							if (fieldCount <= 8) {
								for (const modal of modals) {
									if (modal.style.overflow !== "visible") {
										modal.style.overflow = "visible";
									}
								}
							} else {
								for (const modal of modals) {
									if (modal.style.overflow !== "auto") {
										modal.style.overflow = "auto";
									}
								}
							}
						}
					}

					this.setState({ loading: true }, () => {
						this.fillFields();
					});
				}
			});
		}
	};

	fillFields = () => {
		this.setState({ ...initialState });
		this.matchData();
		[...document.getElementsByClassName("bx--btn bx--btn--secondary")].forEach((element) => {
			if (element.innerHTML === "Create and Add Another") {
				element.disabled = false;
			}
		});
	};

	matchData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		const dataFieldsArray = [];
		for (const dataBucket of configObjs) {
			if (dataBucket[0] !== "ParentData" && dataBucket[0] !== "ChildData") {
				for (const field of dataBucket[1]) {
					if (this.props.data !== undefined) {
						if (this.props.data.hasOwnProperty(field.Name)) {
							setTimeout(() => {
								if (field.DataType === "Select") {
									let optionID = this.props.data[`${field.Name}ID`];

									const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
									if (fieldItem.length > 0) {
										const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.data[field.Name]);
										if (optionItem.length > 0) {
											optionID = optionItem[0].OptionID;
										}
									}

									// Populate Drop Down Fields
									// There are only 7 Parameters accepted: see updateState below to match
									if (optionID != undefined && optionID > 0) {
										dataFieldsArray.push([
											dataBucket[0],
											field.Name,
											{ value: optionID, label: this.props.data[field.Name] },
											field.ID,
											field.DataType,
											false,
											false
										]);
									}
								} else {
									// Populate Free Text Fields
									// There are only 7 Parameters accepted: see updateState below to match
									dataFieldsArray.push([dataBucket[0], field.Name, this.props.data[field.Name], field.ID, field.DataType, false, false]);
								}
							}, 0);
						}
					}
				}
			}
		}
		setTimeout(() => {
			this.updateStatev2(dataFieldsArray);
		}, 0);
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};
	/* END */

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, disabled, this.props.config);
			if (this.state.success === true) {
				this.setState({ success: false });
			}
		}
	};

	updateStatev2 = (dataFieldsArray) => {
		UpdateStateHelper.updatev2(dataFieldsArray, formEl, this, this.props.config);
		if (this.state.success === true) {
			this.setState({ success: false });
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);

			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;

			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			delete postData.RegEx;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			if (postData[this.dataBucketName]) {
				postData[this.dataBucketName].MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData[this.dataBucketName].CampaignID = this.props.metaData.CampaignUniqueIDCode;
				postData[this.dataBucketName].UniqueID = 1;
			}

			const contextValues = BookFiltersStore.getContextValues();

			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				MasterRegionCode: contextValues?.region?.name,
				PlatformID,
				AuditLevelID,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};

			return [formSubmissionObj];
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			if (this.props.type === "Insertion Order") {
				const updatedData = putInsertionOrder(this.postObject, false, true);
			}
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleCreateAndAddAnother = (e) => {
		if (this.state.loading === false) {
			[...document.getElementsByClassName("bx--btn bx--btn--secondary")].forEach((element) => {
				if (element.innerHTML === "Create and Add Another") {
					element.disabled = true;
				}
			});
			this.setState({ loading: true, closeModal: false, success: false }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	checkChildCount = (e) => {
		this.setState({ loading: true, closeModal: true, success: false }, () => {
			e.preventDefault();
			this.sendPostObject(this.state.formData);
		});
	};

	closeConfirmationModal = (event) => {
		if (event) {
			if (!event.currentTarget.classList.contains("bx--modal")) {
				this.setState({ confirmOpen: false });
			}
		} else {
			this.setState({ confirmOpen: false });
		}
	};

	duplicateParentAndChildren = () => {
		const changedFields = [];
		Object.keys(this.state.formData).forEach((formDataKey) => {
			let value = null;
			if (this.state.formData[formDataKey].value !== null) {
				if (typeof this.state.formData[formDataKey].value === "string" && this.state.formData[formDataKey] !== "") {
					value = this.state.formData[formDataKey].value;
				} else if (typeof this.state.formData[formDataKey].value === "object") {
					value = this.state.formData[formDataKey].value.label;
				}
			}
			if (value !== null && value !== this.props.data[formDataKey]) {
				changedFields.push(formDataKey);
			}
		});
		this.setState({ changedFields, loading: true, success: false, confirmOpen: false }, () => {
			this.postObject = this.formDataObjForPost(this.state.formData);
			if (this.postObject) {
				const childData = this.childDataStore.getData();
				const filteredData = childData.filter((data) => {
					return data[this.IDName] === this.props.data[this.IDName];
				});

				const hasChildren = filteredData.length > 0;

				const args = [this.postObject, false, true];

				if (hasChildren) {
					args.push(this.createDuplicateChildren);
				}

				putInsertionOrder(...args);
			}
			if (this.postObject === undefined) {
				this.setState({ loading: false });
			}
		});
	};

	checkForValidValue = (field, fieldValue) => {
		if (this.state.changedFields.includes(field.Name)) {
			if (field.FieldType === "Date" || field.FieldType === "String") {
				return true;
			}
			if (field.FieldType === "Select" || field.DataType === "Select") {
				let optionExists = false;
				field.Options.forEach((placementOption) => {
					if (placementOption.OptionLabel === fieldValue) {
						optionExists = true;
					}
				});
				return optionExists;
			}
		} else {
			return false;
		}
	};

	checkForValidDimensions = (field, fieldValue) => {
		if (this.state.changedFields.includes("Dimensions")) {
			if (field.FieldType === "Date" || field.FieldType === "String") {
				return true;
			}
			if (field.FieldType === "Select" || field.DataType === "Select") {
				let optionExists = false;
				field.Options.forEach((placementOption) => {
					if (placementOption.OptionLabel === fieldValue) {
						optionExists = true;
					}
				});
				return optionExists;
			}
		} else {
			return false;
		}
	};

	createDuplicateChildren = (createdParent) => {
		let parentID = null;
		if (this.props.type === "Insertion Order") {
			InsertionOrderDataStore.resetInsertionOrderErrors();
			parentID = createdParent.InsertionOrderID;
		}
		this.props.updateCounts(this.props.type.replace(/\s+/g, ""));

		const childData = this.childDataStore.getData();
		const filteredData = childData.filter((data) => {
			return data[this.IDName] === this.props.data[this.IDName];
		});
		const config = this.childDataStore.getConfig();
		const parentData = this.props.data;
		filteredData.forEach((row) => {
			row.CampaignID = null;
			row[this.childTaxonomyPropertyName] = null;
			row.TaxonomyData = null;
			row.CreatedBy = null;
			row.UpdatedBy = null;
			row.UniqueID = null;
			row[this.IDName] = parentID;
			// placement.Row = null;
			delete row[this.childIDName];
			if (row.PlatformSiteID) {
				let siteID = null;
				config[this.childDataBucketName].forEach((dataConfig) => {
					if (dataConfig.Name === "PlatformSiteID") {
						dataConfig.Options.forEach((site) => {
							if (site.OptionLabel === row.PlatformSiteID) {
								siteID = site.OptionLabel;
							}
						});
					}
				});
				if (siteID !== null) {
					row.PlatformSiteID = siteID;
				}
			}
		});

		const inheritedData = {};
		for (const dataBucket of Object.entries(config)) {
			if (dataBucket[0] !== "ParentData") {
				for (const field of dataBucket[1]) {
					if (field.Name !== "Rate" && field.Name !== "PlannedUnits" && field.Name !== "Cost") {
						if (parentData.hasOwnProperty(field.Name) && field.Name !== "Size") {
							if (this.state.formData[field.Name]) {
								if (this.state.formData[field.Name].value !== undefined && this.state.formData[field.Name].value !== null) {
									let fieldValue = null;
									if (typeof this.state.formData[field.Name].value === "string") {
										if (field.Name === "StartDate" || field.Name === "EndDate") {
											fieldValue = moment(this.state.formData[field.Name].value).format("MM/DD/YYYY");
										} else {
											fieldValue = this.state.formData[field.Name].value;
										}
									} else if (typeof this.state.formData[field.Name].value === "object") {
										fieldValue = this.state.formData[field.Name].value.label;
									}
									if (fieldValue !== null && this.checkForValidValue(field, fieldValue)) {
										inheritedData[field.Name] = fieldValue;
									}
								}
							}
						} else if (field.Name === "Size") {
							if (parentData.hasOwnProperty("Dimensions")) {
								if (this.state.formData.Dimensions) {
									if (this.state.formData.Dimensions.value !== undefined && this.state.formData.Dimensions.value !== null) {
										let fieldValue = null;
										if (typeof this.state.formData.Dimensions.value === "string") {
											fieldValue = this.state.formData.Dimensions.value;
										} else if (typeof this.state.formData.Dimensions.value === "object") {
											fieldValue = this.state.formData.Dimensions.value.label;
										}
										if (fieldValue !== null && this.checkForValidDimensions(field, fieldValue)) {
											inheritedData.Size = fieldValue;
											inheritedData.PlacementSize = fieldValue;
											inheritedData.Dimensions = fieldValue;
										}
									}
								}
							}
						}
					}
				}
			}
		}

		Object.keys(inheritedData).forEach((inheritedField) => {
			filteredData.forEach((filteredRow) => {
				filteredRow[inheritedField] = inheritedData[inheritedField];
			});
		});

		const filters = BookFiltersStore.getChoicesState();
		let auditLevelID = 0;
		WorkbookStore.getAuditLevels().forEach((auditLevel) => {
			if (auditLevel.AuditLevelName === this.props.childName.replace(/\s+/g, "")) {
				auditLevelID = auditLevel.AuditLevelID;
			}
		});
		const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		const sheetPostObj = [];
		const contextValues = BookFiltersStore.getContextValues();
		/* Config will hold the ID's of the filters */
		// const AgencyID = filters.agency.value;
		// const ClientID = filters.clients.value;
		// const CountryID = filters.country.value;
		// const RegionID = filters.region.value;
		const PlatformID = filters.platform.value;
		const AuditLevelID = this.props.liAuditLevelID;

		for (const item in filteredData) {
			if (filteredData.hasOwnProperty(item)) {
				const lineItemFormattedObj = this.buildPostObjBuckets(filteredData[item], item, parentID);
				if (filteredData[item].UniqueID !== null) {
					lineItemFormattedObj[this.childDataBucketName].UniqueID = filteredData[item].UniqueID;
				}
				if (filteredData[item][this.IDName] !== null) {
					lineItemFormattedObj[this.childDataBucketName][this.IDName] = parentID;
				}
				if (filteredData[item][this.childIDName] !== null) {
					lineItemFormattedObj[this.childDataBucketName][this.childIDName] = filteredData[item][this.childIDName];
				}
				lineItemFormattedObj[this.childDataBucketName].MasterCampaignID = filteredData[item].MasterCampaignID || this.props.metaData.MasterCampaignID;

				lineItemFormattedObj.ParentData = { ParentUniqueIdCode: parentID };
				if (lineItemFormattedObj[this.childDataBucketName].PlatformSiteID !== null) {
					let siteID = null;
					config[this.childDataBucketName].forEach((dataConfig) => {
						if (dataConfig.Name === "PlatformSiteID") {
							dataConfig.Options.forEach((site) => {
								if (site.OptionLabel === lineItemFormattedObj[this.childDataBucketName].PlatformSiteID) {
									siteID = site.OptionID;
								}
							});
						}
					});
					if (siteID !== null) {
						lineItemFormattedObj[this.childDataBucketName].PlatformSiteID = siteID;
					}
				}
				const formSubmissionObj = {
					MasterAgencyDivisionName: contextValues?.agency?.name,
					MasterBusinessUnitName: contextValues?.client?.name,
					MasterCountryCode: contextValues?.country?.name,
					ContextID: contextValues.contextId,
					MasterRegionCode: contextValues?.region?.name,
					PlatformID,
					AuditLevelID,
					CampaignUniqueIDCode: campaignUniqueID
				};

				const mergedItems = Object.assign(formSubmissionObj, lineItemFormattedObj);
				sheetPostObj.push(mergedItems);
			}
		}
		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		choices.auditlevel = { value: AuditLevelID };
		if (this.props.type === "Insertion Order") {
			createChildLineItems(sheetPostObj, choices, this.parentCampaignUniqueID).then(() => {
				setFilteredIO([createdParent.InsertionOrderName, createdParent.InsertionOrderID]);
				InsertionOrderDataStore.updateChildCount(createdParent.InsertionOrderID, sheetPostObj.length);
			});
		}
	};

	buildPostObjBuckets = (lineItem, lineItemID, parentID) => {
		const headerConfigs = Object.entries(this.childDataStore.getConfig());
		const postObj = {};
		// Create Iniital Bucket Arrays
		for (const dataBucket of headerConfigs) {
			if (dataBucket[0] !== "ParentData") {
				if (dataBucket[0] === "TaxonomyData" || dataBucket[0] === "MetaData") {
					postObj[`${dataBucket[0]}`] = [];
				} else {
					postObj[`${dataBucket[0]}`] = {};
				}
			}
		}
		for (const item in lineItem) {
			if (Object.hasOwn(lineItem, item)) {
				const itemKey = item;
				// Check all Buckets from the Config Obj
				for (const dataBucket of headerConfigs) {
					// Process all the data buckets except Parent Data.
					if (dataBucket[0] !== "ParentData") {
						// TaxonomyData or PlacementData
						for (const column of dataBucket[1]) {
							if (column.Name === itemKey.toString()) {
								// Based on DataType do stuff
								if (dataBucket[0] === "TaxonomyData" || dataBucket[0] === "MetaData") {
									if (lineItem[item]) {
										const reformattedValue = this.reformatTaxonomyValue(
											column.DataType,
											column.Options,
											column.Name,
											column.ID,
											lineItem[item] ? lineItem[item] : ""
										);
										postObj[`${dataBucket[0]}`].push(reformattedValue);
									}
								} else if (itemKey === "Rate" || itemKey === "PlannedUnits") {
									if (lineItem[item] !== "") {
										postObj[`${dataBucket[0]}`][`${itemKey}`] = lineItem[item];
									}
								} else {
									postObj[`${dataBucket[0]}`][`${itemKey}`] = lineItem[item];
								}
							}
						}
					}
				}
			}
			if (item === "ParentUniqueIdCode") {
				if (lineItem[item] !== null) {
					postObj.ParentData = { ParentUniqueIdCode: parentID };
				}
			}
		}
		postObj[this.childDataBucketName].UniqueID = lineItemID;
		return postObj;
	};

	reformatTaxonomyValue = (dataType, dataOptions, dataName, dataID, lineItemValue) => {
		if (dataType === "Select") {
			// Match the 'string' to the Options object to get ID
			const matchingOption = dataOptions.filter((option) => option.OptionLabel === lineItemValue.toString());
			if (matchingOption[0] !== undefined) {
				const lineItemID = matchingOption[0].OptionID;
				return {
					dataKeyID: dataID,
					dataValue: {
						dataValueID: lineItemID
					}
				};
			}
		} else {
			return {
				dataKeyID: dataID,
				dataValueIfFreeForm: lineItemValue
			};
		}
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				formInnards = (
					<FormBuilderV2
						type="edit platform"
						data={this.props.config}
						configName="platformConfig"
						onUpdate={this.updateState}
						state={this.state}
						formEl={formEl}
						parentRef={this}
						metaData={this.props.metaData}
					/>
				);
			} else {
				formInnards = <div></div>;
			}
		}

		return (
			<>
				<Modal
					id={formEl}
					className={`clone--${this.props.type} ${isDisabled}`}
					// passiveModal={false}
					heading={`Clone ${this.props.type}`}
					description={`You can make edits inline, then click the 'Clone button' to duplicate the selected ${this.props.type}.`}
					// description={this.props.data && this.props.data.ChildCount > 0 ? `Child ${this.props.childName} Count: ${this.props.data.ChildCount}` : ""}
					isOpen={this.state.open}
					onClick={() => {}}
					onRequestClose={() => {
						this.setState({ open: false });
					}}
					// primaryButtonText="Submit"
					// secondaryButtonText="Create and Add Another"
					// primaryButtonDisabled={this.state.loading}
					// onSecondarySubmit={this.handleCreateAndAddAnother}
					// onRequestSubmit={this.checkChildCount}
					// onRequestClose={this.triggerOpenClose}
					size={"medium"}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="clone-platform-modal-cancel">
									Cancel
								</Button>
								<Button display="primary" onClick={this.duplicateParentAndChildren} data-tracking-id-alt="clone-platform-modal-confirm">
									Clone
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}

					<Heading as={HEADING_LEVEL.H2} size={HEADING_SIZE.EXTRA_SMALL} className="placement-count">
						{this?.props?.data?.ChildCount > 0 ? `Child ${this.props.childName} Count: ${this.props.data.ChildCount}` : ""}
					</Heading>

					<form autoComplete="off">
						<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
						{this.state.showErrors && <div id="errors__container" />}
					</form>
					{this.state.success && (
						<div id="successConfirmation" style={{ color: "green" }}>
							{this.props.type} created successfully!
						</div>
					)}
				</Modal>
				{/* <Modal
					id="confirmDuplicatePlatform"
					className="confirmDuplicatePlatform"
					passiveModal={false}
					modalLabel="Confirm Duplication"
					open={this.state.confirmOpen}
					primaryButtonText="Yes"
					secondaryButtonText="No"
					onSecondarySubmit={this.closeConfirmationModal}
					onRequestClose={this.closeConfirmationModal}
					onRequestSubmit={this.duplicateParentAndChildren}
				>
					{this.props.data && (
						<div style={{ fontWeight: "bold", paddingTop: "5px", paddingBottom: "5px" }}>
							There are {this.props.data.ChildCount} {this.props.childName}(s) in this {this.props.type} that will be copied, do you want to continue?
						</div>
					)}
				</Modal>
				<Modal
					id={"childError"}
					className="childError"
					passiveModal={true}
					danger={true}
					modalLabel="Error"
					open={this.state.childErrorModalOpen}
					onRequestClose={() => {
						this.setState({ childErrorModalOpen: false });
					}}
				>
					<div style={{ fontWeight: "bold", paddingTop: "5px", paddingBottom: "5px" }}>
						The {this.props.type} was created but there was an error with creating {this.props.childName}(s). Please check your {this.props.childName}(s).
					</div>
				</Modal> */}
			</>
		);
	}
}

export default ClonePlatformModal;
